import type { IconData } from '@stacksjs/iconify-core'

export const hardDrive2Solid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M24 1.5c-4.875 0-8.458.173-11.008.382c-3.931.322-6.738 3.366-7.334 7.077L2.627 27.854c2.223-1.95 5.141-3.115 8.234-3.2c3.188-.086 7.49-.154 13.139-.154c5.65 0 9.95.068 13.138.155c3.093.084 6.011 1.25 8.234 3.199l-3.03-18.895c-.596-3.711-3.404-6.755-7.334-7.077C32.458 1.673 28.874 1.5 24 1.5M10.943 46.346c3.158.086 7.431.154 13.057.154s9.9-.068 13.057-.154C42.185 46.207 46.5 42.303 46.5 37s-4.315-9.207-9.443-9.346A485 485 0 0 0 24 27.5c-5.626 0-9.9.068-13.057.154C5.815 27.793 1.5 31.697 1.5 37s4.315 9.207 9.443 9.346M18 35a2 2 0 1 0 0 4h20a2 2 0 1 0 0-4zM8 37a2 2 0 0 1 2-2h1a2 2 0 1 1 0 4h-1a2 2 0 0 1-2-2\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default hardDrive2Solid
